module.exports = __webpack_public_path__ + "img/img2.445d6613.png";